import { GlButton, GlButtonGroup, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import glFeatureFlagMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { viewModeOptions } from 'ee_else_ce/work_items/view_modes';
import { VIEW_MODE_BOARD, VIEW_MODE_TABLE } from '../constants';
export default {
    name: 'WorkItemViewModeToggle',
    components: {
        GlButton,
        GlButtonGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glFeatureFlagMixin()
    ],
    props: {
        viewMode: {
            type: String,
            required: true
        },
        isBoardEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'toggle-view-mode'
    ],
    computed: {
        availableViewModeOptions () {
            return viewModeOptions.filter((option)=>{
                if (option.value === VIEW_MODE_TABLE) {
                    return Boolean(this.glFeatures.planningViewTable);
                }
                if (option.value === VIEW_MODE_BOARD) {
                    return this.isBoardEnabled;
                }
                return true;
            });
        }
    },
    methods: {
        onToggleViewMode (newViewMode) {
            this.$emit('toggle-view-mode', newViewMode);
        },
        isPressed (value) {
            return value === this.viewMode ? 'true' : 'false';
        }
    }
};
